import { ToObject } from "#packages/ecma262-abstract/ToObject.js";
/**
* https://tc39.es/ecma402/#sec-coerceoptionstoobject
* @param options
* @returns
*/
export function CoerceOptionsToObject(options) {
	if (typeof options === "undefined") {
		return Object.create(null);
	}
	return ToObject(options);
}
